import React from "react";
import "./main-input.scss";
function MainInput(props) {
  return (
    <>
    {!props.animation ? (
      <input
      type={props.type || "text"}
      className={props.showborderbottom == "true" ? "coach-input " +(props.value ? "active " : "") + (props.className || "") : "coach-input " + (props.className || "")}
      {...props}
    />
    ):(
    <div id="float-label">
      <label className={ props.value ? "available" : ""}  htmlFor={props.label}>{props.label}</label>
      <input
        type={props.type || "text"}
        className={props.showborderbottom == "true" ? "coach-input " +(props.value ? "active " : "") + (props.className || "") : "coach-input " + (props.className || "")}
        {...props}
      />
    </div>
    
    )}
      
    </>
  );
}

export default MainInput;
